import { MenuLink } from '../Menu'

export const trade: MenuLink[] = [
  { key: 'Trade Program', url: '/en/trade' },
  { key: 'For Commercial Designers', url: '/en/trade/commercial' },
  { key: 'For Residential Designers', url: '/en/trade/residential' },
]
